"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.13,13.32a4.49,4.49,0,0,0-3.2,1.33.51.51,0,0,0,0,.71l5.69,5.69a.5.5,0,0,0,.71,0,4.52,4.52,0,0,0,0-6.4A4.47,4.47,0,0,0,6.13,13.32Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.84,18.65,18.16,13a.51.51,0,0,0-.71,0L16.38,14l-.72-.72,2.56-2.56a3.44,3.44,0,0,0,.26-4.52L19.72,5A1,1,0,0,0,21,4a1,1,0,0,0-1-1,1,1,0,0,0-1,1.25L17.77,5.51h0a3.58,3.58,0,0,0-2.14-.72,3.37,3.37,0,0,0-2.39,1L10.68,8.32,10,7.61,11,6.54a.51.51,0,0,0,0-.71L5.34.15a.5.5,0,0,0-.71,0L1.79,3a.5.5,0,0,0,0,.71L7.48,9.39a.5.5,0,0,0,.71,0L9.26,8.32,10,9,7.73,11.27a.51.51,0,0,0,0,.71L12,16.25a.5.5,0,0,0,.71,0L15,14l.72.72L14.6,15.8a.5.5,0,0,0,0,.71l5.69,5.69a.5.5,0,0,0,.71,0l2.84-2.83A.51.51,0,0,0,23.84,18.65Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.17,22.82a4,4,0,0,1,0-5.69.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71,3,3,0,0,0,0,4.27,3.08,3.08,0,0,0,4.26,0,.51.51,0,0,1,.72,0,.51.51,0,0,1,0,.71A4,4,0,0,1,1.17,22.82Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.07,21a2,2,0,0,1,0-2.84.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71A1,1,0,1,0,5.2,20.27a.5.5,0,0,1,.71.71A2,2,0,0,1,3.07,21Z"
  }));
};

exports["default"] = _default;